import React, { useRef } from 'react';
import FSButton from '@components/FSButton';
import { ContextMenu } from '@shared/contextmenu';
import { ThreeDots } from '@shared/icons/icons';
export default function ImportActionsMenu(_a) {
    var items = _a.items;
    var buttonRef = useRef(null);
    return (React.createElement(React.Fragment, null,
        React.createElement(FSButton, { ref: buttonRef, icon: ThreeDots, "$color": "neutral", "$type": "tertiary", style: { marginLeft: 'auto', marginRight: 'auto' } }),
        React.createElement(ContextMenu, { items: items, triggerRefs: [{ ref: buttonRef, trigger: 'click' }] })));
}
